// libs
import React, { memo, useContext } from "react";
import styled from "@emotion/styled";

// components
import Image from "shared/components/Image";

// helpers
import { getAkamaiUrl } from "shared/helpers/utils";
import { generateTrackingUrlForMegaMenu } from "shared/components/Header/helpers";

//context
import MenuContext from "shared/components/Header/DesktopHeader/components/Menu/MenuContext";

// defs
import { IMapOfString } from "global";
interface IImageLinkProps {
    isBig?: boolean;
    data: IMapOfString;
}

const BIG_IMAGE_WIDTH = 424;
const SMALL_IMAGE_WIDTH = 212;

const Anchor = styled.a<{ isBig?: boolean }>`
    margin-left: 12px;
    cursor: pointer;

    ${({ isBig = false }) => `
        width: ${isBig ? BIG_IMAGE_WIDTH : SMALL_IMAGE_WIDTH}px;
    `}
`;

function ImageLink({ isBig, data }: IImageLinkProps) {
    const { goToUrl } = useContext(MenuContext);
    const width = isBig ? BIG_IMAGE_WIDTH : SMALL_IMAGE_WIDTH;

    const onClick = (e: React.MouseEvent) => {
        e.preventDefault();
        goToUrl(data);
    };

    return (
        <Anchor href={generateTrackingUrlForMegaMenu(data)} isBig={isBig} onClick={onClick}>
            <Image
                src={getAkamaiUrl(data.image_url, { width: width * 2 })}
                width={width}
                aspectRatio={Number(data.aspect_ratio)}
            />
        </Anchor>
    );
}

export default memo(ImageLink);
